import React, { useState } from "react";
import Modal from "components/Models/index";
import useScreenMobile from "hooks/useScreen";
import Drawer from "components/Drawer/index";
import AssignAccessUser from "./AssignAccessUser/AssignAccessUser";
import CreateUser from "./CreateUser/CreateUser";
import "./userContent.scss";
import { ManageUser as MU } from "@induz/sdk";
import { useToast } from "components/Toaster/index"; // Adjust the import path as necessary

const RoleContent = ({
  editModal,
  selectedRow,
  onSubmit,
  handleCancel,
  handleUpdatedata,
  onInviteSuccess
}) => {
  const [steps, setSteps] = useState("role");
  const [roleData, setRoleData] = useState({
    name: selectedRow?.name || "",
    email: selectedRow?.email || "",
    roles: selectedRow?.role || [],
    teams: selectedRow?.team || []
  });

  
  const showToast = useToast();

  const handlestep = async () => {
    try{
      if (roleData.email.trim() === "") {
        alert("Please enter an email address");
      } else {
        await MU.inviteUsersList(roleData.email);
        if (typeof onInviteSuccess === "function") {
          await onInviteSuccess();
        }
      }
      handleCancel();
      showToast("User Invited Successfully", "success");
      setSteps("assign");
    } catch (error) {
      showToast("Please fill all the fields", "error");
      // console.log("Error is", error);
    }
  };

  const updateUserName = (name) => {
    setRoleData((prev) => ({ ...prev, name }));
  };

  const updateEmail = (email) => {
    setRoleData((prev) => ({ ...prev, email }));
  };

  const updateRoles = (roles) => {
    // Ensure roles is always an array
    setRoleData((prev) => ({
      ...prev,
      roles: Array.isArray(roles) ? roles : []
    }));
  };

  const updateTeams = (teams) => {
    // Ensure teams is always an array
    setRoleData((prev) => ({
      ...prev,
      teams: Array.isArray(teams) ? teams : []
    }));
  };

  return (
    <div className="Role">
      <div className="RoleTop">
        <h1> {editModal ? " Edit a user " : "Invite a user"}</h1>
        <p className="text">
          {editModal ? "Add/Edit teams and roles" : "Invite Users to your account by entering their details manually" }
        </p>
        <div className="RoleStepper">
          {!editModal ? <div
            className="Rolesteps first"
            style={{ cursor: "pointer" }}
            onClick={() => {
              if (steps === "assign") {
                setSteps("role");
              }
            }}
          >
            <p>Invite Users</p>
          </div> : <div className="Rolesteps first"
            style={{ cursor: "pointer" }}
            >
            <p>Add Roles and Teams</p>
          </div>}
        </div>
      </div>

      {editModal ? (
        <AssignAccessUser
          updateRoles={updateRoles}
          updateTeams={updateTeams}
          roleData={roleData}
          onSubmit={onSubmit}
          handleCancel={handleCancel}
          editModal={editModal}
          handleUpdatedata={handleUpdatedata}
        />
      ) : (
        <CreateUser
          editModal={editModal}
          handlestep={handlestep}
          updateUserName={updateUserName}
          updateEmail={updateEmail}
          initialEmail={roleData.email}
          initialUserName={roleData.name}
        />
      )}
    </div>
  );
};

function UserContent({
  editModal,
  selectedRow,
  handleCancel,
  onAddRole,
  handleUpdatedata,
  onInviteSuccess
}) {
  const isMobile = useScreenMobile({ size: 992 });
  return (
    <>
      {isMobile ? (
        <Drawer showFooter={false} handleCancel={handleCancel} isVisible={true}>
          <RoleContent
            editModal={editModal}
            selectedRow={selectedRow}
            onSubmit={onAddRole}
            handleCancel={handleCancel}
            handleUpdatedata={handleUpdatedata}
            onInviteSuccess={onInviteSuccess}
          />
        </Drawer>
      ) : (
        <Modal
          title="Create Role"
          showFooter={false}
          showCross={true}
          handleCancel={handleCancel}
          padding="40px"
        >
          <RoleContent
            editModal={editModal}
            selectedRow={selectedRow}
            onSubmit={onAddRole}
            handleCancel={handleCancel}
            handleUpdatedata={handleUpdatedata}
            onInviteSuccess={onInviteSuccess}
          />
        </Modal>
      )}
    </>
  );
}

export default UserContent;
